
class BlogVideo {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement(){
    return this.element;
  }

  getButton() {
    let element = this.getElement();
    return element.querySelectorAll('.js-play');
  }
  
  getClose() {
    let element = this.getElement();
    return element.querySelector('.js-videoClose');
  }

  setClosePlayer() {
    let closeEl = this.getClose();
    closeEl.addEventListener('click', () => {
      this.setClose();
    })
  }

  getVideoContainer() {
    let element = this.getElement();
    return element.querySelector('.js-videoContainer')
  }

  setVideoContainerClose() {
    let videoContainerEl = this.getVideoContainer();
    videoContainerEl.addEventListener('click', () => {
      this.setClose();
    })
  }

  showVideoContainer() {
    let videoEl = this.getVideoContainer();
    videoEl.classList.add('active');
  }

  getPlayer() {
    let element = this.getElement();
    return element.querySelector('.js-iframe')
  }

  setClose() {
    let videoContainerEl = this.getVideoContainer();
    let playerEl = this.getPlayer();

    playerEl.src = '';
    videoContainerEl.classList.remove('active');
  }


  setButton() {
    let buttonEl = this.getButton();
    let playerEl = this.getPlayer();

    for(let button of buttonEl) {
      button.addEventListener('click', () => {
        let src = button.dataset.src;
        playerEl.src = src;
        this.showVideoContainer();

      })
    }
  }

  setEventHandlers() {
    this.setButton();
    this.setVideoContainerClose();
    this.setClosePlayer();
  }

  init() {
    this.setEventHandlers();
  }
}


const BlogVideoInit = {
  init() {
    const $el = document.querySelector(".js-blog");
    if ($el) {
        new BlogVideo($el);
    }
  },
};


export default BlogVideoInit;

